
<template>
	<c-dialog ref="dialog" width="650" mode="slide" mask-close @close="dialogFormEditConfirm($refs.taskForm, arguments)" @resolve="editHandle">
		<c-form ref="taskForm" unit-width="100%">
			<c-form-item label="工单编号">
				<c-select name="work_id" async v-model="work_id" @search="searchWork" :value-data="workOptions" @change="changeWork" :disabled="editState" :clear="false">
					<template #option="{data, selected}">
						<select-option
							:name="data.name"
							:info="[
								textJoin(data.data.product_code, data.data.product_name, data.data.product_spec)
							]"
							:selected="selected"
						></select-option>
					</template>
				</c-select>
				<info-card code="WORK_PRODUCT" :id="work_id"></info-card>
			</c-form-item>
			<!-- <c-form-item label="产品编号">
		   		<c-input name="product_code" disabled></c-input>
			</c-form-item>
			<c-form-item label="产品名称">
		   		<c-input name="product_name" disabled></c-input>
			</c-form-item>
			<c-form-item label="产品规格">
		   		<c-input name="product_spec" disabled></c-input>
			</c-form-item> -->
			<c-form-item label="工序" required>
				<c-select name="process_id" async @search="searchProcess" :value-data="processOptions" @change="changeProcess" :clear="false" :disabled="this.editState">
                    <template #option="{data, selected}">
                        <select-option
                            :name="data.name"
                            :image="data.data.process_image"
                            :selected="selected"
                        ></select-option>
                    </template>
                </c-select>
				<template #handle>
					<c-link icon v-if="auth('b_process_edit') && !editState" @click="globalDialog('processEdit')">创建工序</c-link>
				</template>
			</c-form-item>
			<c-form-item label="任务状态" v-if="task_id" :tip="work_state!=2?'工单非『执行中』不允许变更任务状态':''">
				<c-radio-group name="state" :options="orderStateNoCancelDic" @change="changeTaskState($event)" :disabled="!auth('b_task_edit_state') || work_state != 2"></c-radio-group>
			</c-form-item>
			<c-form-item label="报工数配比" required>
		   		<c-input name="output_ratio" type="number" decimal="6" :range="[0.000001,99999999]"></c-input>
			</c-form-item>
			<c-form-item label="计划数" required>
				<c-input type="stepper" name="plan_count" stepControls="side"  decimal="6" :range="[0.000001,99999999]"></c-input>
			</c-form-item>
			<c-form-item label="计划时间" required>
				<c-datetime start-name="plan_start_date" end-name="plan_end_date" type="datetime" range time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
				<template #handle>
					<c-link icon v-if="auth('m_schedule_calendar')" icon="tf-calendar" @click="windowTo({name: 'm_schedule_calendar', query: {task: true}})">排产日历</c-link>
				</template>
			</c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remark"></c-input>
			</c-form-item>
			<c-form-item label="生产顺序">
				<c-radio-group name="production_sequence" :options="productionSequenceDic" :clear="false"></c-radio-group>
			</c-form-item>
			<c-form-item label="加工类型">
				<c-radio-group name="process_type" :options="processTypeDic" v-model="process_type" :disabled="freeEdition" @change="processTypeHandle"></c-radio-group>
				<div v-if="freeEdition" style="margin-top:-20px;margin-left:-85px;">
					<c-tooltip tip="此功能为【专业版】功能，请开通专业版后使用" align="end">
						<template><img src="@/assets/image/vip.png" alt="" style="height: 14px;"></template>
					</c-tooltip>
				</div>
			</c-form-item>
			<c-form-item label="检验方式">
				<c-radio-group name="test_mode" :options="testModeDic" v-model="test_mode" :disabled="process_type==2 || freeEdition" @change="testModeHandle"></c-radio-group>
				<div v-if="freeEdition" style="margin-top:-20px;margin-left:-85px;">
					<c-tooltip tip="此功能为【专业版】功能，请开通专业版后使用" align="end">
						<template><img src="@/assets/image/vip.png" alt="" style="height: 14px;"></template>
					</c-tooltip>
				</div>
			</c-form-item>
			<c-form-item label="物料自动出库" :tip="process_type==1?'自制：当前工序报工后,对应工序需要用到的物料会自动出库,无需手动操作领料':'外协：当前工序对应的委外单发货时,对应外协工序需要用到的物料会自动出库,无需手动发料'">
				<c-radio-group name="material_auto_out" :options="openCloseDic"></c-radio-group>
				<!-- <c-switch name="material_auto_out" :state-value="[1, 0]" :state-text="['开启','不启用']" ></c-switch> -->
			</c-form-item>
			<c-form-item label="成品自动入库" tip="当前工序报工后,生产的成品会自动入库,无需手动再操作入库">
				<c-radio-group name="product_auto_in" :options="openCloseDic" :disabled="test_mode!=1"></c-radio-group>
				<!-- <c-switch name="product_auto_in" :state-value="[1, 0]" :state-text="['开启','不启用',]" ></c-switch> -->
			</c-form-item>
			<c-form-item label="报工前打卡" tip="工人开始工作时手动打卡,只有存在开始工作打卡记录才允许报工">
				<c-radio-group name="output_start" :options="openCloseDic" :disabled="process_type==2"></c-radio-group>
			</c-form-item>
			<custom-form ref="customForm" work-type="9"></custom-form>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState, mapGetters} from "vuex";

export default {
	computed: {
		...mapState(['orderStateNoCancelDic', 'productionSequenceDic','processTypeDic','testModeDic','openCloseDic']),
		...mapGetters(['freeEdition'])
	},
	
	data() {
		return {
			editState: false,
			work_id: 0,
			task_id: 0,
			work_state: 1,
			work_plan_count: 1,
			process_type:1,
			test_mode:1,
			workOptions: [],
			processOptions: []
		}
	},
	
	// 监听器
	watch: {
		
	},
	
	methods: {
		/************打开新增、编辑弹窗**************/
		open(data, opt) {
			this.editState = !!data;
			this.$refs.taskForm.clear();
			this.$refs.customForm.init({
				formulaSource: {
					name: '任务',
					form: this.$refs.taskForm,
					watch: {
						'work_id': (data, resolve) => {
							data.work_id && this.request({
								url: '/work/overview',
								data: {
									id: data.work_id
								},
								success: data => {
									resolve({
										'工单': data.detailInfo
									});
								}
							});
						}
					}
				}
			});
			if (data) {
				this.task_id = data.id;
				this.getDetail();
			}else {
				this.task_id = 0;
				//工单基本信息
				if (opt && opt.planDate) {
					this.$refs.taskForm.set({
						plan_start_date: opt.planDate[0],
						plan_end_date: opt.planDate[1],
					});
				} else {
					this.$refs.taskForm.set({
						plan_start_date: new Date().format('yyyy-MM-dd 00:00'),
						plan_end_date: new Date().format('yyyy-MM-dd 23:59')
					});
				}
				this.$refs.taskForm.set({
					production_sequence:1,
					output_ratio:1,
					process_type:1,
					test_mode:1,
					output_start:0,
					material_auto_out:0,
					product_auto_in:0
				});
			}
			this.$refs.dialog.open({
				title: this.editState ? '编辑任务' : '创建任务'
			});
		},

		/*******搜索任务详情*******************/
		getDetail() {
			this.request({
				url:'/task/detail',
				data: {
					id: this.task_id
				},
				loading: true,
				success: data => {
					this.work_state = data.work_state;
					//工单基本信息
					this.$refs.taskForm.set(data);
					
					//处理选中工单信息
					this.workOptions = [{
						name: data.work_code,
						value: data.work_id
					}];
					
					//处理选中工序信息
					this.processOptions = [{
						name: data.process_code +' | ' +data.process_name,
						value: data.process_id
					}];
				}
			});
		},

		/*******搜索【工单】下拉框信息*****************/
		searchWork(keyword, resolve){
			this.request({
				url:'/work/optionList',
				data: {
					keyword:keyword,
					work_states: [1, 2]
				},
				success:data => {
					var option = data.map(item => {
						return {
							name: item.work_code,
							value: item.id,
							data: item
						}
					});
					resolve(option);
				}
			})
		},
		
		/********变更工单下拉框数据*************/
		changeWork({data}){
			this.work_plan_count = data.plan_count;
			this.$refs.taskForm.set({
				product_code: data.product_code,
				product_name: data.product_name,
				product_spec: data.product_spec,
				plan_count: this.work_plan_count
			});
			this.$refs.customForm.setDefaultData({
				work_type_id: 9,
				source_list: [[{
					ref_work_type_id: 3,
					ref_id: data.id
				}]]
			});
		},

		/*******搜索【工序】下拉框信息*****************/
		searchProcess(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'DICPROCESS',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/********变更工序下拉框数据*************/
		changeProcess(selectData){
			this.$refs.taskForm.set({
				output_ratio: selectData.data.output_ratio,
				plan_count: this.work_plan_count * selectData.data.output_ratio
			});
		},
		
		/**加工类型变更事件*/
		processTypeHandle(data){
			if(data == 2){
				this.$refs.taskForm.set({
					test_mode:1,
					output_start: 0,
					material_auto_out:0
				});
			}
		},
		
		/**检验方式变更事件*/
		testModeHandle(data){
			if(data != 1){
				this.$refs.taskForm.set({
					product_auto_in:0
				});
			}
		},
		
		/********变更任务工序状态*************/
		changeTaskState(state){
			this.request({
				url:'/task/editState',
				data: {
					id: this.task_id,
					state: state
				},
				success:data => {
					this.$message({
						type: 'success',
						message:'任务状态变更成功',
					});
					//刷新任务列表数据
					this.$bus.$emit('task.list.update', {});
				}
			})
		},

		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			
			this.$refs.taskForm.submit({
				url: this.editState ? '/task/edit':'/task/add',
				rule: {
					work_id: '请选择工单',
					process_id: '请选择工序',
					output_ratio: '请输入报工数配比',
					plan_start_date: '请选择计划开始时间',
					plan_end_date: '请选择计划结束时间',
					plan_count: '请输入任务计划数',
					...this.$refs.customForm.rule
				},
			    dataFormatter: data => {
					data.id = this.task_id||0;
					data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						type: 'success',
						message:this.editState ? '编辑任务成功' : '创建任务成功',
					});
					//刷新页面
					this.$emit('resolve');
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>